import { Injectable } from '@angular/core';

import { ApiCategoryList } from 'idt-ecommerce-api/_api/api-catalog/api-categories/api-categories.models';
import { ApiStoreDetail, ApiStoreList } from 'idt-ecommerce-api/_api/api-catalog/api-stores/api-stores.models';
import { ApiCmsTranslations } from 'idt-ecommerce-api/_api/providers/api-cms/api-cms-translations/api-cms-translations.models';

import type { StorefrontMenu } from 'idt-ecommerce-api/_api/api-navigation-storefront/api-navigation-storefront.models';
import type { Seo } from 'idt-ecommerce-api/seo/seo.models';


export type RenderSetupData = Partial<{
  categories: ApiCategoryList;
  menuItems: StorefrontMenu;
  seo: Seo;
  store: ApiStoreDetail;
  stores: ApiStoreList;
  translations: ApiCmsTranslations;
}>;

@Injectable({
  providedIn: 'root'
})
export class RenderSetupDataService {

  private data: RenderSetupData | undefined;

  public get categories(): ApiCategoryList | undefined {
    return this.data?.categories;
  }

  public get menuItems(): StorefrontMenu | undefined {
    return this.data?.menuItems;
  }

  public get seo(): Seo | undefined {
    return this.data?.seo;
  }

  public get store(): ApiStoreDetail | undefined {
    return this.data?.store;
  }

  public get stores(): ApiStoreList | undefined {
    return this.data?.stores;
  }

  public get translations(): ApiCmsTranslations | undefined {
    return this.data?.translations;
  }

  public set setupData(data: RenderSetupData | undefined) {
    this.data = data;
  }

}
